
import { defineComponent } from "vue"
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { spatialOmicsApi } from "@/request";
import { Data } from "@/types/Request";
import { ElMessageBox } from 'element-plus'

export default defineComponent({
  data() {
    return {
      startDate: '',
      endDate: '',
      countryList: [],
      journalList: [],
      tissueList: [],
      speciesList: [],
      biotechCategoryList: [],
      biotechList: [],
      selectedCountry: '',
      selectedJournal: '',
      selectedTissue: '',
      selectedSpecies: '',
      selectedBiotechCategory: '',
      selectedBiotech: null,
      histologyAvailability: false,
      dataListData: [],
      dataListOriginData: [],
      pageSize: 10,
      currentPageData: [],
      currentPage: 1,
      currentData: '',
      searchName: '',
      router: useRouter(),
      store: useStore()
    }
  },
  methods: {
    /**
     * 初始化一些搜索列表
     */
    init () {
      spatialOmicsApi.getALLInfo().then((res) => {
        this.biotechCategoryList = res.data['biotech_categories']
        this.countryList = res.data['country']
        this.journalList = res.data['journal']
        this.tissueList = res.data['tissue']
        this.speciesList = res.data['species']
      })
    },

    /**
     * 根据当前biotech类别的变动更新biotech的列表
     */
    biotechCategoryChangeCallback () {
      console.log(this.selectedBiotechCategory)
      spatialOmicsApi.getBiotechListByBiotechType(this.selectedBiotechCategory).then((res) => {
        console.log('res', res)
        this.biotechList = res.data
      })
    },

    /**
     * 根据dataset名字进行搜索当前的dataset列表
     */
    searchDataByName () {
      console.log(this.searchName)
      if (this.searchName === '') {
        this.dataListData = this.dataListOriginData
      } else {
        this.dataListData = this.dataListOriginData.filter((item: any) => item.name.indexOf(this.searchName) !== -1)
      }
      this.gotoPage(1)
    },

    /**
     * 根据当前搜索条件获取data列表
     */
    searchData () {
      // console.log(this.startDate,this.endDate)
      let criteria: { [k: string]: any } = {}
      if (this.startDate != '' && this.endDate != '') {
        if (!/^\d+$/.test(this.startDate) || !/^\d+$/.test(this.endDate)) {
          alert('Please enter the correct year! (for example 2020)')
          return
        }
        criteria['date'] = [Number(this.startDate), Number(this.endDate)]
      } else if (this.startDate != '' || this.endDate != '') {
        if (this.startDate != '') {
          if (!/^\d+$/.test(this.startDate)) {
            alert('Please enter the correct year! (for example 2020)')
            return
          }
          criteria['date'] = [Number(this.startDate), 9999]
        } else {
          if (!/^\d+$/.test(this.endDate)) {
            alert('Please enter the correct year! (for example 2020)')
            return
          }
          criteria['date'] = [0, Number(this.endDate)]
        }
      }
      if (this.selectedCountry != '') {
        criteria['country'] = this.selectedCountry
      }
      if (this.selectedJournal != '') {
        criteria['journal'] = this.selectedJournal
      }
      if (this.selectedBiotechCategory != '') {
        criteria['biotech_category'] = this.selectedBiotechCategory
      }
      if (this.selectedBiotech != null) {
        criteria['biotech_id'] = this.selectedBiotech
      }
      if (this.selectedSpecies != '') {
        criteria['species'] = this.selectedSpecies
      }
      if (this.selectedTissue != '') {
        criteria['tissue'] = this.selectedTissue
      }
      criteria['histology_availability'] = this.histologyAvailability
      let criteriaInfo = {
        'criteria': criteria
      }

      spatialOmicsApi.dataSearch(criteriaInfo).then((res) => {
        console.log('data search: ', res)
        this.dataListOriginData = res.data
        this.dataListData = res.data
        this.gotoPage(1)
      })
    },
    /**
     * 清空筛选条件
     */
    clearData(){
      this.selectedCountry = ''
      this.selectedJournal = ''
      this.selectedTissue = ''
      this.selectedSpecies = ''
      this.selectedBiotechCategory = ''
      this.selectedBiotech = null
      this.dataListData = []
      this.dataListOriginData = []
      this.gotoPage(1)
    },

    /**
     * 跳至data列表的某页
     * @param whichPage 页码数
     */
    gotoPage (whichPage: number) {
      let currentPage = whichPage || this.currentPage
      let start = this.pageSize * (currentPage - 1)
      let end = start + this.pageSize
      this.currentPageData = this.dataListData.slice(start, end)
      this.currentPage = currentPage
    },

    /**
     * 选择某一data，并更新DataView组件
     * @param data
     */
    selectData (data: Data) {
      console.log(data)
      this.router.push({
        name: 'data',
        query: {
          'dataID': data.id
        }
      })
    },
    //download事件处理
    download() {
      ElMessageBox.alert('This work is under review, please email jianhuayao at tencent.com for inquiring the downloading support. This download button will be activated upon publication', '', )
    }
  },
  mounted () {
    this.init()
  }
})

